import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = {
  key: 7,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"10px","margin-bottom":"0px"}
}, null, -1)
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_nota_fiscal_detalhe_pagamento_modal = _resolveComponent("nota-fiscal-detalhe-pagamento-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_table, {
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.computedDetalhesPagamento,
          rowKey: "codigo",
          pagination: false,
          scroll: { y: 200},
          size: "small",
          rowClassName: "ss-table-campos",
          "row-selection": { selectedRowKeys: _ctx.state.idselecionados, onChange: _ctx.mudarSelecao }
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
          ]),
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    onClick: ($event: any) => (_ctx.editarDetalhe(index))
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_4),
                  (_ctx.props.editavel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "excluir",
                        onClick: ($event: any) => (_ctx.excluirDetalhe(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'NumeroTitulo')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.numeroTitulo), 1))
                : (column.key === 'TipoDocumentoFinanceiro')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 1))
                  : (column.key === 'Vencimento')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1))
                    : (column.key === 'ValorTotal')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal, 2, true)), 1))
                      : (column.key === 'Conta')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.descricaoConta), 1))
                        : (column.key === 'Categoria')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(record.nomePlanoContaCategoria), 1))
                          : (column.key === 'DetalhePagamento')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.editarDetalhe(index))
                                  }, [
                                    _createElementVNode("span", null, "Título: " + _toDisplayString(record.numeroTitulo), 1)
                                  ], 8, _hoisted_13)
                                ]),
                                _createElementVNode("span", null, "Conta: " + _toDisplayString(record.descricaoConta), 1),
                                _createElementVNode("span", null, "Categoria " + _toDisplayString(record.nomePlanoContaCategoria), 1),
                                _createElementVNode("span", null, "Vencimento: " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1),
                                _createElementVNode("span", null, "Valor: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor, 2, true)), 1),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("a", {
                                    class: "visualizar",
                                    onClick: ($event: any) => (_ctx.editarDetalhe(index))
                                  }, [
                                    _createVNode(_component_icone, { nome: "editar" })
                                  ], 8, _hoisted_15),
                                  (_ctx.props.editavel)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        class: "excluir",
                                        onClick: ($event: any) => (_ctx.excluirDetalhe(index))
                                      }, [
                                        _createVNode(_component_icone, { nome: "excluir" })
                                      ], 8, _hoisted_16))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "row-selection"])
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_a_form_item, {
            label: " ",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.adicionarDetalhe && _ctx.adicionarDetalhe(...args)))
              }, "Inserir novo")
            ]),
            _: 1
          }),
          (_ctx.state.idselecionados.length > 1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: " ",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editarDetalhesSelecionados && _ctx.editarDetalhesSelecionados(...args)))
                  }, "Editar Selecionados")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.state.idselecionados.length > 1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                label: " ",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.excluirDetalhesSelecionados && _ctx.excluirDetalhesSelecionados(...args)))
                  }, "Excluir Selecionados")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_a_form_item, {
          label: "Quantidade",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createElementVNode("input", {
              type: "text",
              class: "ant-input",
              style: {"text-align":"right"},
              value: _ctx.detalhesPagamento.length,
              disabled: "true"
            }, null, 8, _hoisted_22)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_a_form_item, {
          label: "Total",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              quantidadeCasasDecimais: 2,
              valor: _ctx.calculaTotalDetalhePagamento(),
              disabled: true
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ])
    ]),
    _renderSlot(_ctx.$slots, "RecursoExtra"),
    _createVNode(_component_nota_fiscal_detalhe_pagamento_modal, {
      classeCss: "ss-modal-compras",
      visivel: _ctx.state.exibirLancamento,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
      empresa: _ctx.props.empresa,
      detalhePagamento: _ctx.state.detalheSelecionado,
      "onUpdate:detalhePagamento": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.detalheSelecionado) = $event)),
      detalhesPagamento: _ctx.state.detalhesSelecionados,
      "onUpdate:detalhesPagamento": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.detalhesSelecionados) = $event)),
      editavel: _ctx.props.editavel,
      onSalvar: _ctx.salvarDetalhe
    }, null, 8, ["visivel", "empresa", "detalhePagamento", "detalhesPagamento", "editavel", "onSalvar"])
  ]))
}